import { z } from "zod";

import { api } from "~/api";
import { createServiceResponseSchema } from "../schemas";
import { stateSchema } from "./schemas";

export const statesDataModelSchema = z.array(stateSchema);

export const getStatesList = async (isEligible?: boolean) => {
  const params =
    isEligible !== undefined ? { isEligible: isEligible.toString() } : {};
  const response = await api.get("states", { params });

  return createServiceResponseSchema(statesDataModelSchema).parse(response.data)
    .data;
};
